export const tr = {
    adaptive: 'Uyarlanır',
    create: 'Şunun bazında oluştur'
};
